// Initiate search context
import { createContext } from "react";

const userSearchContext = createContext();

export default userSearchContext;
